import { render, staticRenderFns } from "./Relatorios2.vue?vue&type=template&id=f8e9ba18&scoped=true&"
import script from "./Relatorios2.vue?vue&type=script&lang=js&"
export * from "./Relatorios2.vue?vue&type=script&lang=js&"
import style0 from "./Relatorios2.vue?vue&type=style&index=0&id=f8e9ba18&prod&lang=scss&scoped=true&"
import style1 from "./Relatorios2.vue?vue&type=style&index=1&id=f8e9ba18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e9ba18",
  null
  
)

export default component.exports